/**
 * Returns a react-hook-form validate function that fails when the value
 * is empty or only whitespace, with the given error message.
 */
export function requiredNoWhitespace(message: string) {
  return (value: unknown) =>
    typeof value === "string" && value.trim().length === 0 ? message : true;
}
